import React from 'react'
import DashboardNav from './Components/DashboardNav'
import Visit from './Components/Visit'
import Footer from '../LandingPage/Components/Footer'

function VisitPage() {
    return (
        <div>
            <DashboardNav />
            <Visit />
            <Footer />
        </div>
    )
}

export default VisitPage